export default __webpack_public_path__ + "static/media/tete26.9ce8c182.png";